// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"b39ec030","116":"0b758856","120":"71802a61","236":"414ba075","261":"414ba075","324":"1819f233","621":"1819f233","845":"414ba075","878":"007081ee"}[chunkId] + ".chunk.css";
};